import React from 'react';
import HeroSection from './HeroSection';
import classNames from 'classnames';
import logo from '../assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const menu = [
  {
    name: 'Home',
    href: '/',
    id: 'home',
  },
  {
    name: 'About Us',
    href: '#aboutus',
    id: 'aboutus',
  },
  {
    name: 'Tokenomics',
    href: '#tokenomics',
    id: 'tokenomics',
  },
  {
    name: 'Roadmap',
    href: '#roadmap',
    id: 'roadmap',
  },
  {
    name: 'Community',
    href: 'https://t.me/pupepe_erc',
    id: 'community',
  },
];

export default function Header({ setOpen, headerOpen }) {
  return (
    <div className=" header-image  text-white bg-opacity-20 " id="home">
      <div className="bg-header bg-opacity-25">
        <header className="container mx-auto px-6 ">
          <div
            className={`mx-4 py-5 sm:py-5 md:py-10 lg:pt-20 sm:mx-4 md:mx-4 lg:mx-6 2xl:mx-0 ${
              headerOpen && 'h-screen overflow-hidden'
            }`}
          >
            <Disclosure as="nav" className="">
              {({ open, close }) => {
                setOpen(open);
                return (
                  <>
                    <div className="flex justify-between">
                      <div
                        className={`flex animate__animated animate__lightSpeedInLeft  animate__delay-1s ${
                          open ? 'hidden' : 'block'
                        }`}
                      >
                        <div className="flex lg:flex-1">
                          <Link to="/" className="-m-1.5 p-1.5">
                            <div className="flex gap-[10px]">
                              <img className=" w-auto" src={logo} alt="Pepe" />
                              <div className="flex items-center font-Sniglet text-[32px] leading-10 ">
                                Purple PEPE
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="flex items-center animate__animated animate__bounceInDown animate__delay-1s text-base tracking-wide">
                        <div className="hidden lg:ml-6 lg:flex lg:items-center">
                          <div className="hidden lg:-my-px lg:ml-6 lg:flex lg:space-x-14 font-SingleDay text-xl font-normal">
                            {menu.map((item) => (
                              <a
                                key={item.name}
                                href={item.href}
                                target={`${item.name === 'Community' ? '_blank' : '_self'}`}
                                className=" hover:text-purple "
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                          {/* <div className="hidden md:-my-px md:ml-12 md:flex md:space-x-8 animate__animated animate__backInRight">
                            <button className="font-Salsa button-bg text-white text-base leading-5 font-normal py-3 px-8 rounded-[50px] ">
                              Get $POPE
                            </button>
                          </div> */}
                        </div>
                      </div>
                      <div className="lg:hidden items-center flex">
                        <div className="-mr-2 flex items-center lg:hidden">
                          <Disclosure.Button className=" inline-flex items-center justify-center rounded-lg p-2 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-0">
                            <span className="sr-only">Open main menu</span>
                            {open ? (
                              <XMarkIcon
                                className="block h-6 w-6 focus:ring-offset-0"
                                aria-hidden="true"
                              />
                            ) : (
                              <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                            )}
                          </Disclosure.Button>
                        </div>
                      </div>
                    </div>

                    <Disclosure.Panel className="bg-header-mobile animate__animated animate__slideInDown animate__faster absolute left-0 right-0 top-16 flex h-screen flex-col justify-evenly lg:hidden">
                      <div className="absolute -top-[44px] left-4">
                        <div className="flex lg:flex-1">
                          <Link to="/" className="-m-1.5 p-1.5">
                            <div className="flex gap-[10px]">
                              <img className=" w-auto" src={logo} alt="police Pepe" />
                              <div className="flex items-center font-Sniglet text-[32px] leading-10 ">
                                Purple PEPE
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="grid gap-5 font-Caveat space-y-1 pt-2 pb-3 text-2xl font-SingleDay font-medium text-center animate__animated animate__bounceInDown animate__delay-1s">
                        {menu.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            onClick={() => close()}
                            target={`${item.name === 'Community' ? '_blank' : '_self'}`}
                            className={({ isActive }) =>
                              classNames(
                                isActive
                                  ? ''
                                  : 'hover:bg-aquamarine-400 border-transparent text-nobel hover:border-gray-300 hover:text-gray-800',
                                'block py-2 pl-3 pr-4 '
                              )
                            }
                          >
                            {' '}
                            {item.name}
                          </a>
                        ))}
                      </div>

                      {/* <div className="flex justify-center animate__animated animate__backInDown">
                        <button className="font-Salsa button-bg text-white text-base leading-5 font-normal py-3 px-8 rounded-[50px]">
                          Get $POPE
                        </button>
                      </div> */}
                    </Disclosure.Panel>
                  </>
                );
              }}
            </Disclosure>
          </div>
        </header>
        {!headerOpen && <HeroSection />}
      </div>
    </div>
  );
}
